import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const managetMaterialReceive = createAsyncThunk(
  "/user/manageMaterialReceive",
  async ({ id, payload }) => {
    try {
        
      const url = id
        ? `${V_URL}/user/manage-receive-issue/${id}`
        : `${V_URL}/user/manage-receive-issue`;

      const response = await axios({
        method: "post",
        url: url,
        data: payload,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
        },
      });
      const data = response?.data;
      if (data.success === true) {
        return data;
      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.log(error, "error");
      toast.error(error.response.data.message);
      return error;
    }
  }
);

const managetMaterialReceiveSlice = createSlice({
  name: "managetMaterialReceive",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(managetMaterialReceive.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(managetMaterialReceive.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(managetMaterialReceive.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default managetMaterialReceiveSlice.reducer;
